export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  chart:{
    unused: '#C0DCE8',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#E56B10',
    contrastText: '#FFF',
    light: '#f9e1cf',
  },
  secondary: {
    main: '#231942',
    contrastText: '#002855',
  },
  text: {
    primary: '#231942',
    secondary: '#5A6D8E',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#F9F7FF',
    paper: '#FFF',
    light: '#EDE9FF',
    default: '#FFF',
    footer: '#002855',
    level2: '#ea8841',
    level1: '#FFF',
    tableHead: '#DDDDDD',
    tableSubhead: '#4d236c1a',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#F8D859',
  },
  verticalBar: {
    used: '#E56B10',
    unused: '#f9e1cf',
    unlimited: '#C0C0C0',
  }
};
